import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getProjectSummaryReports = async (projectId) => {
    const { data } = await vlqrApi.get(`projects/${projectId}/projectSummaryReports`)
        .catch((error) => {
            handleError(error);
        });

    return data;
};

const useProjectSummaryReports = (projectId, options = {}) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['projectSummaryReports', projectId],
        queryFn: () => getProjectSummaryReports(projectId),
        ...options
    });

    return { data, refetch, isLoading, isError };
};

export default useProjectSummaryReports;
